interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "DOP";
};

const DOP: Currency = Object.freeze({
  "displayName": "Dominican Peso",
  "numericCode": 214,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "DOP",
  "symbol": "$"
});

export { DOP };
